export default __webpack_public_path__ + "static/media/slider_3.dd7927af.jpg";